module.exports = __webpack_public_path__ + "assets/img/familyCrest-d31bec64.png";